module.exports = __webpack_public_path__ + "img/china-flag.252a3e7f.png";